// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__FB7XP","meals-appear":"AvailableMeals_meals-appear__OHNp4"};